var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5714_428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4384 165.562L43.5171 192.673L72.8647 208.21L99.9765 181.099L84.4384 165.562Z",
    fill: "#B6B8B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4384 165.56L68.9003 150.023L41.7905 177.133L50.4223 199.576L84.4384 165.56Z",
    fill: "#CED0CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.681 30.3203L125.768 82.8007L73.2881 176.713C113.713 217.138 179.256 217.138 219.681 176.713C260.106 136.288 260.106 70.7455 219.681 30.3203Z",
    fill: "#5C6F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2877 30.3189C32.8624 70.7441 32.8624 136.286 73.2877 176.712L219.681 30.3189C179.256 -10.1063 113.713 -10.1063 73.2877 30.3189Z",
    fill: "#7A888A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.965 51.0352L131.631 88.6625L94.0039 155.996C122.988 184.98 169.981 184.98 198.965 155.996C227.948 127.012 227.949 80.019 198.965 51.0352Z",
    fill: "#A7DCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0039 51.0351C65.0195 80.0194 65.0195 127.012 94.0039 155.996L198.965 51.0351C169.981 22.0508 122.988 22.0508 94.0039 51.0351Z",
    fill: "#D2ECFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.607 61.3945L134.563 91.5956L104.362 145.639C127.625 168.903 165.343 168.903 188.607 145.639C211.87 122.376 211.87 84.6582 188.607 61.3945Z",
    fill: "#D2ECFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.362 61.393C81.0982 84.6567 81.0982 122.374 104.362 145.638L188.607 61.393C165.343 38.1294 127.625 38.1294 104.362 61.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42529 243.574C14.9927 252.141 28.9321 252.141 37.4995 243.574L72.8646 208.209L57.3275 192.672L24.9658 211.223L6.42529 243.574Z",
    fill: "#5C6F74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7905 177.137L6.42534 212.502C-2.14202 221.069 -2.14154 235.009 6.42534 243.576L57.3276 192.674L41.7905 177.137Z",
    fill: "#7A888A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.305 108.697L173.069 140.461L183.427 130.103L151.663 98.3392L141.305 108.697Z",
    fill: "#F85B3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.542 76.9276L141.306 108.691L151.664 98.3335L119.9 66.5697L109.542 76.9276Z",
    fill: "#FF7F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.539 130.099L119.897 140.457L183.425 76.9293L173.067 66.5714L109.539 130.099Z",
    fill: "#F85B3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5714_428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.b35379fa0d7c8108c9de16148357fced.svg";
export { ForwardRef as ReactComponent };